import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getCardById } from "../../../api/apiServices";
import { useQuery } from 'react-query';


const ViewCard = (props) => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
    const params = useParams();
    const id = parseInt(params.id)

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/global_cards";

    const {
        isLoading,
        isError,
        error,
        data: card
    } = useQuery(['card', id], () => getCardById(id));


    const handleCancel = () => {
        navigate(from, { replace: true });
    }

    let content
    if (isLoading) {
        content = <p>Loading...</p>
    } else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content = (

            <div className="data-table">
                <legend style={{ fontSize: "24px", fontWeight: "700", color: "white" }}>Member Card Information</legend>
                <div className="profile-picture">
                    <img src={`/images/members/${card?.profile_picture}`} className="image" alt="" />
                </div>
                <table className="table table-borderless">
                    <tbody>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>PF Number</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "no-wrap" }}> :	{card.pf_number}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Card Issued</td>
                            {card?.issued_status === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	YES</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NO </td>

                            )}
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Name</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{card?.first_name} {card?.middle_name} {card?.last_name}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Date Issued</td>
                            {card?.issued_status === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{card?.date_issued}</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NULL </td>

                            )}
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Region</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{card?.region}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Issued To</td>
                            {card?.issued_status === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{card?.issued_to}</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NULL </td>

                            )}
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Sent To Printer</td>
                            {card?.sent_to_printer === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	YES</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NO </td>
                            )}
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Issued By</td>
                            {card?.issued_status === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{card?.issued_by}</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NULL </td>

                            )}
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Received From Printer</td>
                            {card?.sent_to_printer === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	YES</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NO </td>

                            )}
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Collected By</td>
                            {card?.issued_status === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{card?.collected_by}</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NULL </td>

                            )}
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Card Status</td>
                            {card?.card_status === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	GENERATED</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NOT GENERATED</td>

                            )}
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Data Collected</td>
                            {card?.issued_status === true ? (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{card?.date_collected}</td>
                            ) : (
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	NULL </td>

                            )}
                        </tr>
                    </tbody>
                </table>
            </div>

        );
    }

    return (
                <>
            <section className="content-header">
                <h1>Membership Card </h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            Member Card Details
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                <form>
                                    <div className="form-group row">
                                        <div className="col-sm-2">
                                            <button type="submit" className="btn btn-danger" onClick={ handleCancel }>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ViewCard;


